export enum GiftThresholds {
  '100K' = 100000,
  '250K' = 250000,
  '500K' = 500000,
  '1M' = 1000000,
}
